import { WEB_APP_URLS } from '@bikemap/js/settings'
import { gettext } from '../../services'
import { renderImg, renderIcon } from '../../utility'
import Marker from './Marker'
import { getWebAppParams } from '@bikemap/js/integrations/global/web-app-links'

/**
 * A map marker representing a route.
 */
export default class RouteMarker extends Marker {

    /**
     * @param {Object} lngLat Position of the marker
     * @param {string} [icon="i-bike"] The main category of the route
     * @param {string} [url] URL the marker should link to
     */
    constructor(lngLat, icon = 'i-bike', url) {
        const element = document.createElement('div')
        element.className = 'route-marker'

        const image = renderImg('markers/route.svg', gettext('Starting point'), '36', '48')
        element.append(image)

        const iconEl = renderIcon(icon, 'white')
        element.append(iconEl)

        if (url) {
            const link = document.createElement('a')
            link.href = url
            link.textContent = gettext('Route details')
            element.append(link)
        }

        super(lngLat, element, [0, -22])
    }

}

/**
 * @param {import("../../entities").Route} route
 * @returns {RouteMarker}
 */
RouteMarker.fromRoute = function (route) {
    const url = WEB_APP_URLS.WEB_APP_ROUTE_DETAILS_URL.replace(':id', route.id) + getWebAppParams()
    return new RouteMarker(route.start, route.getIcon(), url)
}
